import { Component, OnInit, ViewChild } from "@angular/core";
import { ListingService } from "@app/services/listing.service";
import { Listing } from "@app/data/listing";
import { UntypedFormControl } from "@angular/forms";
import { UntypedFormGroup } from "@angular/forms";
import { UntypedFormBuilder } from "@angular/forms";
import { Page } from "@app/data/page";
import * as _ from "underscore";

import {
  ListingsTableComponent,
  INVENTORY_LIMIT,
} from "@app/components/platform/listings-table.component";

const SAMPLES_COLORS = ["Red", "Blue", "Yellow", "Green", "Purple"];

@Component({
  templateUrl: "./inventory-list.component.html",
})
export class InventoryListComponent implements OnInit {
  hideNavbar: boolean;
  @ViewChild("listingsTable")
  listingsTable: ListingsTableComponent;
  isLoading: boolean = false;
  page = new Page();
  rows = new Array<Listing>();
  keywordsFormControl = new UntypedFormControl();
  formGroup: UntypedFormGroup;
  isAddingListing = false;
  keywords: string = "";
  rowsSelected = [];
  pageInitialized = false;

  constructor(
    private listingService: ListingService,
    private formBuilder: UntypedFormBuilder
  ) {}
  ngOnInit() {
    this.page.pageNumber = 0;
    this.filter();
  }

  filter(keywords: string = "") {
    this.isLoading = true;
    this.rows = [];
    this.listingService
      .getInventory(
        this.page.pageNumber * INVENTORY_LIMIT,
        INVENTORY_LIMIT,
        keywords
      )
      .then((result) => {
        this.isLoading = false;
        if (!this.pageInitialized) {
          this.page.size = result.size;
          this.page.totalElements = result.total;
          this.page.totalPages = result.numberOfPages;
          this.pageInitialized = true;
        }

        this.rows = [...result.listings];
      });
  }
}
